export default __webpack_public_path__ + "static/media/img4.4cf9df2b.jpg";